export default __webpack_public_path__ + "static/media/pencil_img.6926a882.svg";